module.exports = __webpack_public_path__ + "static/media/MrsGloria.d57f1ff9.png";